import { formatDate, mediaUrl } from "@/lib/api";

export const MagazineIssueList = ({ items, current, onSelect }) => (
  <div className="space-y-3" data-testid="magazine-issues-list">
    {items.map((m, i) => (
      <button key={m.id} data-testid={`magazine-issue-${i}`} onClick={() => onSelect(m)} className={`w-full text-left news-card flex gap-3 p-3 ${current?.id === m.id ? "ring-2 ring-red-600" : ""}`}>
        <div className="w-14 aspect-[3/4] bg-zinc-200 shrink-0 overflow-hidden">{m.cover_url && <img src={mediaUrl(m.cover_url)} alt="" className="w-full h-full object-cover" />}</div>
        <div className="min-w-0">
          <div className="badge-cat">{m.edition}</div>
          <h4 className="font-heading font-bold text-sm mt-1 line-clamp-2">{m.title}</h4>
          <div className="text-xs text-zinc-500 mt-1">{formatDate(m.published_at)}</div>
        </div>
      </button>
    ))}
    {!items.length && <p className="text-sm text-zinc-500">Aucune édition disponible.</p>}
  </div>
);
